(() => {
  const mobile = window.matchMedia('(max-width: 749px)');
  const controls = 'a[href], button, input:not([type="hidden"]), select, textarea, summary, [role="button"], [tabindex="0"]';
  let pending = false;
  let activeHost;
  let activeButton;
  let buttonObserver;
  let hostObserver;
  let runtimeObserver;
  let observedRuntime;

  const visibleRect = (element) => {
    const rect = element.getBoundingClientRect();
    if (!rect.width || !rect.height) return null;
    const style = getComputedStyle(element);
    return style.visibility === 'hidden' || style.display === 'none' ? null : rect;
  };

  const place = () => {
    pending = false;
    const host = document.querySelector('shopify-chat');
    if (!host) return;
    if (host !== activeHost) {
      activeHost = host;
      hostObserver?.disconnect();
      if (host.shadowRoot) {
        hostObserver = new MutationObserver(schedule);
        hostObserver.observe(host.shadowRoot, { childList: true, subtree: true });
      }
    }

    const runtime = host.shadowRoot?.querySelector('shopify-agent-runtime');
    if (runtime !== observedRuntime && runtime?.shadowRoot) {
      observedRuntime = runtime;
      runtimeObserver?.disconnect();
      runtimeObserver = new MutationObserver(schedule);
      runtimeObserver.observe(runtime.shadowRoot, { childList: true, subtree: true });
    }
    const button = runtime?.shadowRoot?.querySelector('[part~="activator"]');
    if (!button) return;
    if (button !== activeButton) {
      activeButton = button;
      buttonObserver?.disconnect();
      buttonObserver = new MutationObserver(schedule);
      buttonObserver.observe(button, { attributes: true, attributeFilter: ['aria-expanded'] });
    }

    if (!mobile.matches) {
      host.style.removeProperty('--tcg-chat-clearance');
      host.removeAttribute('data-tcg-chat-obstructed');
      return;
    }
    if (button.getAttribute('aria-expanded') === 'true') {
      host.removeAttribute('data-tcg-chat-obstructed');
      return;
    }

    const current = button.getBoundingClientRect();
    if (!current.width || !current.height) return;
    const previous = parseFloat(host.style.getPropertyValue('--tcg-chat-clearance')) || 0;
    const baseTop = current.top - previous;
    let top = baseTop;
    const gap = 10;
    const viewportTop = window.visualViewport?.offsetTop || 0;
    const viewportBottom = viewportTop + (window.visualViewport?.height || window.innerHeight);
    let minTop = viewportTop + gap;
    const header = document.querySelector('header');
    if (header) {
      const rect = header.getBoundingClientRect();
      if (rect.top <= viewportTop + gap && rect.bottom > viewportTop) minTop = rect.bottom + gap;
    }
    top = Math.min(top, viewportBottom - current.height - gap);
    const obstacles = Array.from(document.querySelectorAll(controls))
      .filter((element) => !host.contains(element))
      .map(visibleRect)
      .filter((rect) => rect && rect.bottom > minTop && rect.top < viewportBottom && rect.right > current.left - gap && rect.left < current.right + gap)
      .sort((a, b) => b.top - a.top);

    for (const rect of obstacles) {
      if (top < rect.bottom + gap && top + current.height > rect.top - gap) top = rect.top - current.height - gap;
    }
    const obstructed = top < minTop;
    if (host.hasAttribute('data-tcg-chat-obstructed') !== obstructed) host.toggleAttribute('data-tcg-chat-obstructed', obstructed);
    if (!obstructed) {
      const offset = `${Math.round(top - baseTop)}px`;
      if (host.style.getPropertyValue('--tcg-chat-clearance') !== offset) host.style.setProperty('--tcg-chat-clearance', offset);
    }
  };

  function schedule() {
    if (!pending) {
      pending = true;
      requestAnimationFrame(place);
    }
  }

  window.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', schedule, { once: true });
  window.visualViewport?.addEventListener('resize', schedule, { passive: true });
  window.visualViewport?.addEventListener('scroll', schedule, { passive: true });
  mobile.addEventListener('change', schedule);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  customElements.whenDefined('shopify-chat').then(schedule);
  customElements.whenDefined('shopify-agent-runtime').then(schedule);
  document.fonts?.ready.then(schedule);
  schedule();
})();
